import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FeeCode } from 'src/app/enums/fee.code';
import { Fees } from 'src/app/model/fees';
import { CommonUtil } from 'src/app/services/common.util';

@Component({
    selector: 'app-agent-fees',
    templateUrl: './agent-fees.component.html',
    styleUrls: ['./agent-fees.component.css'],
})
export class AgentFeesComponent {
    @Input() agentFeeList: Array<Fees>;
    @Input() editAgent = false;
    @Input() showEditPencil = true;
    @Input() parentToUpdate = false;
    @Input() title = 'Agent User';
    @Output() updateFee = new EventEmitter();

    feeCode = FeeCode;
    feeLabel = this.commonUtil.getFeeLabels();

    constructor(public commonUtil: CommonUtil) { }

    changeView() {
        this.editAgent = !this.editAgent;
    }

    submit() {
        this.updateFee.emit('agent');
        this.changeView();
    }

}
